import Image from "./Images/Men-Fashiodn 1.png";
import { AiOutlineLeft, AiOutlineLock } from "react-icons/ai";
import { BiUser, BiSolidShoppingBags } from "react-icons/bi";
import { BsWallet2 } from "react-icons/bs";
import { MdLocationOn } from "react-icons/md";
import { CiLogout } from "react-icons/ci";
import { RiDeleteBin5Line } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import * as main_category from "../../network/api/maincategory";
import { getprofileapi } from "../../network/api/user";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

function Sidebar({ setShowSidebar }) {
    const {t} = useTranslation();
  
  const navigate = useNavigate();
  const [id, setid] = useState("");
  const [fullName, setFullName] = useState({});

  useEffect(() => {
    getprofileapi().then((response) => {

      setFullName((prev) => ({
        ...prev,
        firstName: response.response.first_name,
        lastName: response.response.last_name,
      }));
    });
  }, []);
  useEffect(() => {
    main_category
      .getcategories()
      .then((result) => {
        const firstId = result?.data?.response?.[0]?._id;
        if (firstId) setid(firstId);
      })
      .catch(() => {
        // no-op
      });
  }, []);
  return (
    <div className="nav-sidebar">
      <div className="sidebar">
        <div
          className="d-flex justify-content-end"
          style={{
            margin: "2rem 1.19rem",
            fontSize: "30px",
            cursor: "pointer",
            color: "#948D8D",
          }}
          onClick={() => setShowSidebar(false)}
        >
          <AiOutlineLeft />
        </div>
        <h1>
          {" "}
          {fullName && Object.keys(fullName).length > 0
            ? `${fullName.firstName} ${fullName.lastName}`
            : ""}
        </h1>
        <ul className="m-5 p-0 ">
          <Link
            style={{ textDecoration: "none", color: "black" }}
            to="/profile"
            onClick={() => setShowSidebar(false)}
          >
            <li className="d-flex justify-content-between align-items-center">
              <div>
                <BiUser />
                <span className="me-3">{t("MyAccount")}</span>
              </div>
              <AiOutlineLeft />
            </li>
          </Link>

          <Link
            style={{ textDecoration: "none", color: "black" }}
            to="/returns"
            onClick={() => setShowSidebar(false)}
          >
            <li className="d-flex justify-content-between align-items-center">
              <div>
                <BiUser />
                <span className="me-3">{t("Returns")}</span>
              </div>
              <AiOutlineLeft />
            </li>
          </Link>

          <Link
            style={{ textDecoration: "none", color: "black" }}
            to="/myorders"
            onClick={() => setShowSidebar(false)}
          >
            <li className="d-flex justify-content-between align-items-center">
              <div>
                <BiSolidShoppingBags />
                <span className="me-3">{t("myOrders")}</span>
              </div>
              <AiOutlineLeft />
            </li>
          </Link>

          <Link
            style={{ textDecoration: "none", color: "black" }}
            to="/mywallet"
            onClick={() => setShowSidebar(false)}
          >
            <li className="d-flex justify-content-between align-items-center">
              <div>
                <BsWallet2 />
                <span className="me-3">{t("myWallet")}</span>
              </div>
              <AiOutlineLeft />
            </li>
          </Link>

          <Link
            style={{ textDecoration: "none", color: "black" }}
            to="/addresses"
            onClick={() => setShowSidebar(false)}
          >
            <li className="d-flex justify-content-between align-items-center">
              <div>
                <MdLocationOn />
                <span className="me-3">{t("Addresses")}</span>
              </div>
              <AiOutlineLeft />
            </li>
          </Link>

          <Link
            style={{ textDecoration: "none", color: "black" }}
            to="/changepassword"
            onClick={() => setShowSidebar(false)}
          >
            <li className="d-flex justify-content-between align-items-center">
              <div>
                <AiOutlineLock />
                <span className="me-3">{t("ChangePassword")}</span>
              </div>
              <AiOutlineLeft />
            </li>
          </Link>

          <li
            style={{ cursor: "pointer" }}
            onClick={async () => {
              Cookies.remove("user");
              Cookies.remove("mycart");
              Cookies.remove("mywish");
              navigate("/");
              window.location.reload();
            }}
            className="d-flex justify-content-between align-items-center"
          >
            <div>
              <CiLogout />
              <span className="me-3">{t("LogOut")}</span>
            </div>
            <AiOutlineLeft />
          </li>

          <Link
            style={{ textDecoration: "none", color: "black" }}
            to="/deleteaccount"
            onClick={() => setShowSidebar(false)}
          >
            <li className="d-flex justify-content-between align-items-center">
              <div style={{ color: "#D94A27" }}>
                <RiDeleteBin5Line />
                <span className="me-3">{t("DeleteAccount")}</span>
              </div>
            </li>
          </Link>
        </ul>
      </div>
    </div>
  );
}
export default Sidebar;
